// extracted by mini-css-extract-plugin
export default {"link":"Menu_link__nuspu","menu":"Menu_menu__8aQn3","circles":"Menu_circles__VdAW-","circleTop":"Menu_circleTop__xjh8o","circle1":"Menu_circle1__5jyZR"};